import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for group members hooks
 * Keys match backend controller method names
 */
export const groupMembersKeys = {
  findAll: (groupUuid: string, params?: QueryParamsDto) =>
    params
      ? (["group-members", groupUuid, "findAll", params] as const)
      : (["group-members", groupUuid, "findAll"] as const),
  findOne: (groupUuid: string, memberUuid: string) =>
    ["group-members", groupUuid, "findOne", memberUuid] as const,
} as const
